import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import { withSuperJSONProps as _withSuperJSONProps } from "babel-plugin-superjson-next/tools";
import SubscriptionPage from "@saas-pages/Subscription/SubscriptionPage";
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { NextPage, NextPageContext } from "next";
import { SubscriptionPageI } from "@saas-interface";
import SubscriptionServices from "@saas-services/SubscriptionServices";
import AnalyticsServices from "@saas-services/AnalyticsServices";
AnalyticsServices.init.piwik = null;
AnalyticsServices.init.hotjar = null;
const PricingIndex: NextPage<SubscriptionPageI> = props => <SubscriptionPage {...props} external={true} autoFontSize={false} />;
export const getStaticProps = _withSuperJSONProps(async function getStaticProps(context: NextPageContext) {
  const location_id = context.locale === 'fr-FR' ? 73 : 229;
  const datas = await SubscriptionServices.getProducts(location_id);
  return {
    props: {
      datas,
      location_id,
      trialDay: 7,
      hidePack: true,
      ...(await serverSideTranslations(context.locale ?? 'en-US', ['stripe']))
    }
  };
}, []);
export default _withSuperJSONPage(PricingIndex);